import JsCookie from 'js-cookie';

export const Cookies = JsCookie.withAttributes({
  sameSite: 'strict',
  secure: window.location.protocol === 'https:',
  expires: 30,
});
